import React, { memo } from 'react';
import { ZapIcon, ShieldIcon, HeartIcon, DropletIcon } from 'lucide-react';
const FunctionalShots = () => {
  return <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
        <div className="text-center mb-16" data-id="element-282">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-blue-500 text-white shadow-sm mb-4" data-id="element-283">
            PATENTED TECHNOLOGY
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-284">
            Premium Beverage Options
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-285">
            Our patented solution offers customizable beverage options designed
            to enhance your showroom experience and impress your customers
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-286">
          {/* Refreshing Option */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-287">
            <div className="bg-yellow-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-288">
              <ZapIcon className="h-8 w-8 text-yellow-500" data-id="element-289" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-290">
              Signature Refreshments
            </h3>
            <p className="text-gray-600 text-center" data-id="element-291">
              Create custom beverage options that reflect your brand identity
              and provide a memorable touchpoint in your customer journey.
            </p>
            <div className="mt-6 text-center" data-id="element-292">
              <span className="inline-block px-3 py-1 bg-yellow-50 text-yellow-700 rounded-full text-sm font-medium" data-id="element-293">
                ⚡ Brand enhancing
              </span>
            </div>
          </div>
          {/* Premium Waters */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-294">
            <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-295">
              <ShieldIcon className="h-8 w-8 text-green-500" data-id="element-296" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-297">
              Premium Waters
            </h3>
            <p className="text-gray-600 text-center" data-id="element-298">
              Offer still, sparkling, or alkaline water options that demonstrate
              your attention to detail and customer care.
            </p>
            <div className="mt-6 text-center" data-id="element-299">
              <span className="inline-block px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium" data-id="element-300">
                🛡️ Quality focused
              </span>
            </div>
          </div>
          {/* Flavor Infusions */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-301">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-302">
              <HeartIcon className="h-8 w-8 text-blue-500" data-id="element-303" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-304">
              Flavor Infusions
            </h3>
            <p className="text-gray-600 text-center" data-id="element-305">
              Choose from 29+ flavor options that can be customized to match
              your brand colors or seasonal promotions.
            </p>
            <div className="mt-6 text-center" data-id="element-306">
              <span className="inline-block px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm font-medium" data-id="element-307">
                🧘 Customizable options
              </span>
            </div>
          </div>
          {/* Vitamin-Enhanced */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-308">
            <div className="bg-cyan-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-309">
              <DropletIcon className="h-8 w-8 text-cyan-500" data-id="element-310" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-311">
              Vitamin-Enhanced
            </h3>
            <p className="text-gray-600 text-center" data-id="element-312">
              Offer wellness-focused options that appeal to health-conscious
              customers and demonstrate your progressive approach.
            </p>
            <div className="mt-6 text-center" data-id="element-313">
              <span className="inline-block px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm font-medium" data-id="element-314">
                💧 Wellness focused
              </span>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-white p-8 rounded-xl shadow-md max-w-4xl mx-auto" data-id="element-315">
          <h3 className="text-2xl font-bold text-navy-950 mb-4 text-center" data-id="element-316">
            The Ultimate Showroom Enhancement
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-317">
            <div data-id="element-318">
              <ul className="space-y-4" data-id="element-319">
                <li className="flex" data-id="element-320">
                  <div className="flex-shrink-0" data-id="element-321">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-322">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-323">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-324" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-325">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-326">
                      Personalized Experience
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-327">
                      Customers can customize their beverages based on their
                      personal preferences, creating a memorable interaction
                      with your brand.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-328">
                  <div className="flex-shrink-0" data-id="element-329">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-330">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-331">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-332" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-333">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-334">
                      Premium Options
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-335">
                      Support your brand positioning with a variety of premium
                      beverage choices that reflect your commitment to quality.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div data-id="element-336">
              <ul className="space-y-4" data-id="element-337">
                <li className="flex" data-id="element-338">
                  <div className="flex-shrink-0" data-id="element-339">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-340">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-341">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-342" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-343">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-344">
                      Enhance Customer Satisfaction
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-345">
                      Offer a premium amenity that customers will appreciate and
                      mention in their reviews and recommendations.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-346">
                  <div className="flex-shrink-0" data-id="element-347">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-348">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-349">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-350" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-351">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-352">
                      Elevate Your Brand
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-353">
                      Create memorable impressions with a unique beverage
                      experience that distinguishes your showroom from
                      competitors.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-354">
            <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-355">
              Schedule Your Demo Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default FunctionalShots;